import { Injectable } from '@angular/core';
import { EthnicGroup } from 'src/app/models/data/ethnic-group.model';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { environment } from './../../../environments/environment';
import { User } from 'src/app/models/data/user.model';

@Injectable({
  providedIn: 'root',
})
export class EthnicService {
  ethnicGroups = new Subject<EthnicGroup[]>();
  allEthnicGroups = new Subject<EthnicGroup[]>();
  localUser!: User;

  ethnics!: EthnicGroup[];
  constructor(private http: HttpClient) { }

  addEthnicGroup(ethnicGroup: EthnicGroup, status: string) {
    const ethnicc = new EthnicGroup(
      ethnicGroup.Name,
      ethnicGroup.Language || null,
      ethnicGroup.Location || null,
      ethnicGroup.Action,
      ethnicGroup.Status,
      Number(ethnicGroup.Workers),
      Number(ethnicGroup.WorkersBenefitted),
      Number(ethnicGroup.Churches),
      Number(ethnicGroup.Believers),
      Number(ethnicGroup.AmountPerWorker),
      Number(ethnicGroup.Year),
    );
    this.getUserData();
    let headers = new HttpHeaders({
      token: this.localUser.token,
      'Content-Type': 'application/json',
    });
    console.log(status);
    let type: string;
    if (status == 'Current') {
      type = 'current';
    } else {
      type = 'future';
    }
    console.log(type);
    return this.http
      .post(`${environment.apiUrl}/EG`, ethnicc, {
        headers: headers,
      })
      .pipe(
        map((res) => {
          console.log('updated succesfully ' + res);
          this.getEthnicGroups(type);
        }),
      );
  }

  getUserData() {
    const user: User = <User>JSON.parse(localStorage.getItem('user') as string);
    this.localUser = user;
  }

  updateEthnicGroup(
    ethnicGroup: EthnicGroup,
    id: number | undefined,
    status: string,
  ) {
    ethnicGroup.EthnicGroupID ? id == ethnicGroup.EthnicGroupID : id == id;
    console.log(id);
    const ethnic = new EthnicGroup(
      ethnicGroup.Name,
      ethnicGroup.Language,
      ethnicGroup.Location,
      ethnicGroup.Action,
      ethnicGroup.Status,
      Number(ethnicGroup.Workers),
      Number(ethnicGroup.WorkersBenefitted),
      Number(ethnicGroup.Churches),
      Number(ethnicGroup.Believers),
      Number(ethnicGroup.AmountPerWorker),
      Number(ethnicGroup.Year),
    );
    this.getUserData();
    let headers = new HttpHeaders({
      token: this.localUser.token,
      'Content-Type': 'application/json',
    });
    let type: string;
    if (status == 'Current') {
      type = 'current';
    } else {
      type = 'future';
    }
    console.log(ethnicGroup);
    return this.http
      .put(`${environment.apiUrl}/EG/${id}`, ethnic, {
        headers: headers,
      })
      .pipe(
        tap((res) => {
          console.log('updated succesfully ' + res);
          console.log(type);
          this.getEthnicGroups(type);
        })
      );
  }

  updateEthnicGroupField(
    id: number,
    fieldName: string,
    fieldValue: any,
    status: string
  ) {
    // Find the existing ethnic group from current data
    const existingEthnic = this.ethnics.find(ethnic => ethnic.EthnicGroupID === id);
    if (!existingEthnic) {
      console.error(`Ethnic group with ID ${id} not found`);
      return;
    }

    // Create updated ethnic group with the new field value
    const updatedEthnic = new EthnicGroup(
      existingEthnic.Name,
      existingEthnic.Language,
      existingEthnic.Location,
      existingEthnic.Action,
      existingEthnic.Status,
      Number(existingEthnic.Workers),
      Number(existingEthnic.WorkersBenefitted),
      Number(existingEthnic.Churches),
      Number(existingEthnic.Believers),
      Number(existingEthnic.AmountPerWorker),
      Number(existingEthnic.Year),
    );

    // Update the specific field
    (updatedEthnic as any)[fieldName] = fieldValue;

    this.getUserData();
    let headers = new HttpHeaders({
      token: this.localUser.token,
      'Content-Type': 'application/json',
    });
    
    let type: string;
    if (status == 'Current') {
      type = 'current';
    } else {
      type = 'future';
    }
    
    return this.http
      .put(`${environment.apiUrl}/EG/${id}`, updatedEthnic, {
        headers: headers,
      })
      .subscribe((res) => {
        console.log(`Field ${fieldName} updated successfully:`, res);
        this.getEthnicGroups(type);
      });
  }

  getEthnicGroups(status: string) {
    this.getUserData();
    let headers = new HttpHeaders({
      token: this.localUser.token,
      'Content-Type': 'application/json',
    });
    let type;
    if (status == 'current') {
      type = 'Current';
    } else {
      type = 'Future';
    }

    return this.http
      .get(`${environment.apiUrl}/EG/${type}`, {
        headers: headers,
      })
      .subscribe((res) => {
        this.ethnics = <EthnicGroup[]>res;

        this.ethnicGroups.next(this.ethnics);
      });
  }

  getAllEthnicGroups() {
    this.getUserData();
    let headers = new HttpHeaders({
      token: this.localUser.token,
      'Content-Type': 'application/json',
    });

    return this.http
      .get(`${environment.apiUrl}/EG`, {
        headers: headers,
      })
      .subscribe((res) => {
        this.ethnics = <EthnicGroup[]>res;

        this.allEthnicGroups.next(this.ethnics);
      });
  }

  deleteEthnic(ethnicGroup: EthnicGroup, status: string) {
    let id = ethnicGroup.EthnicGroupID;
    this.getUserData();
    let headers = new HttpHeaders({
      token: this.localUser.token,
      'Content-Type': 'application/json',
    });
    return this.http
      .delete(`${environment.apiUrl}/EG/${id}`, {
        headers: headers,
      })
      .subscribe((res) => {
        console.log('deleted succesfully ' + res);
        console.log(status);
        this.getEthnicGroups(status);
      });
  }

  getEthnicOb() {
    return this.ethnicGroups.asObservable();
  }

  getAllEthnicOb() {
    return this.allEthnicGroups.asObservable();
  }
}
